/* TAMA GEORGINA — Refonte (interactions) — thème brouillon uniquement */
(function(){
  "use strict";
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* ---------- Compte à rebours : prochain mercredi 18h00 ---------- */
  function nextDrop(){
    var now = new Date();
    var d = new Date(now);
    var day = d.getDay();            // 0 dim .. 3 mer
    var add = (3 - day + 7) % 7;
    d.setDate(d.getDate() + add);
    d.setHours(18,0,0,0);
    if (d <= now) d.setDate(d.getDate() + 7);
    return d;
  }
  function pad(n){ return (n<10?'0':'') + n; }
  function tick(){
    var els = document.querySelectorAll('.tama-count');
    if(!els.length) return;
    var t = nextDrop() - new Date();
    if(t < 0) t = 0;
    var dd = Math.floor(t/864e5), hh = Math.floor(t/36e5)%24, mm = Math.floor(t/6e4)%60, ss = Math.floor(t/1e3)%60;
    els.forEach(function(el){
      el.querySelectorAll('[data-c]').forEach(function(b){
        var k = b.getAttribute('data-c');
        b.textContent = k==='d'?pad(dd):k==='h'?pad(hh):k==='m'?pad(mm):pad(ss);
      });
    });
  }

  /* ---------- Compteur qui monte (compteur Insta) ---------- */
  function animCount(el){
    var to = parseInt(el.getAttribute('data-to')||'0',10);
    var fmt = function(n){ return Math.round(n).toLocaleString('fr-FR'); };
    if(RM){ el.textContent = fmt(to); return; }
    var dur = 1600, start = null;
    function step(ts){
      if(start===null) start = ts;
      var p = Math.min(1,(ts-start)/dur);
      var e = 1 - Math.pow(1-p,3);
      el.textContent = fmt(to*e);
      if(p<1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ---------- Reveal au scroll (visible au repos si pas d'IO) ---------- */
  function reveals(){
    var els = document.querySelectorAll('.tama-reveal');
    if(!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('in');}); return; }
    var io = new IntersectionObserver(function(ents){
      ents.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
    },{rootMargin:'0px 0px -8% 0px', threshold:.06});
    var vh = window.innerHeight;
    els.forEach(function(e){
      var top = e.getBoundingClientRect().top;
      if(top < vh*0.92){ e.classList.add('in'); }
      else { e.classList.add('armed'); io.observe(e); }
    });
  }

  function counters(){
    var cs = document.querySelectorAll('.tama-counter');
    if(!cs.length) return;
    if(!('IntersectionObserver' in window)){ cs.forEach(animCount); return; }
    var co = new IntersectionObserver(function(es){
      es.forEach(function(en){ if(en.isIntersecting){ animCount(en.target); co.unobserve(en.target); } });
    },{threshold:.4});
    cs.forEach(function(c){ co.observe(c); });
  }

  function init(){
    reveals();
    counters();
    tick();
    setInterval(tick, 1000);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
